const { getOffsetTop } = window.BAO.Utils

class ProductDescription extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTabChange = this.handleTabChange.bind(this)
    this.handleReadMore = this.handleReadMore.bind(this)

    this.els.trigger?.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.handleTabChange)
    })

    this.listeners.add(
      this.externalEls?.readmore?.element,
      'click',
      this.handleReadMore,
    )
  }

  handleTabChange (event) {
    const clickedTrigger = event.target

    this.els.trigger.elements.forEach((triggerEl) => {
      triggerEl.setAttribute(
        'aria-pressed',
        triggerEl.dataset.tab === clickedTrigger.dataset.tab,
      )
    })

    this.els.panel?.elements.forEach((panelEl) => {
      panelEl.setAttribute(
        'aria-hidden',
        panelEl.dataset.tab !== clickedTrigger.dataset.tab,
      )
    })
  }

  handleReadMore () {
    window.scrollTo({
      top: getOffsetTop(this) - 30,
      left: 0,
      behavior: 'smooth',
    })

    this.els.trigger.elements.forEach((triggerEl) => {
      triggerEl.setAttribute(
        'aria-pressed',
        triggerEl.dataset.tab === 'description',
      )
    })

    this.els.panel?.elements.forEach((panelEl) => {
      panelEl.setAttribute(
        'aria-hidden',
        panelEl.dataset.tab !== 'description',
      )
    })
  }
}

if (!customElements.get('product-description')) {
  customElements.define('product-description', ProductDescription)
}
